export default __webpack_public_path__ + "static/media/trash.90a4794c.svg";